import styled from "styled-components";

export const PageContainer = styled.div`
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    padding: 16px;
    border-radius: 8px;
    background: linear-gradient(135deg, #f9fafb 0%, #e5e7eb 100%);
`;
